import ManageEmployeeContract from '../../../views/Personnel/Letter/ManageEmployeeContract.letter.view';

export default ManageEmployeeContract;
